import { render } from "./PenalidadesManagement.vue?vue&type=template&id=fd5f6648&scoped=true"
import script from "./PenalidadesManagement.vue?vue&type=script&lang=js"
export * from "./PenalidadesManagement.vue?vue&type=script&lang=js"

import "./PenalidadesManagement.vue?vue&type=style&index=0&id=fd5f6648&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fd5f6648"]])

export default __exports__